import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActionsBar = ({ selectedCount, onAction, onClear }) => {
  const [selectedAction, setSelectedAction] = useState('');

  const actionOptions = [
    { value: '', label: 'Select action...' },
    { value: 'publish', label: 'Publish Games' },
    { value: 'unpublish', label: 'Unpublish Games' },
    { value: 'feature', label: 'Mark as Featured' },
    { value: 'unfeature', label: 'Remove from Featured' },
    { value: 'delete', label: 'Delete Games' },
    { value: 'export', label: 'Export Data' }
  ];

  const handleApplyAction = () => {
    if (selectedAction) {
      onAction(selectedAction);
      setSelectedAction('');
    }
  };

  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-40">
      <div className="bg-card border border-border rounded-lg shadow-gaming-xl p-4">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
              <Icon name="CheckSquare" size={16} className="text-primary" />
            </div>
            <span className="text-sm font-medium text-foreground">
              {selectedCount} game{selectedCount !== 1 ? 's' : ''} selected
            </span>
          </div>

          <div className="w-px h-6 bg-border" />

          <div className="flex items-center space-x-3">
            <Select
              placeholder="Select action..."
              options={actionOptions}
              value={selectedAction}
              onChange={setSelectedAction}
              className="w-48"
            />

            <Button
              variant="default"
              size="sm"
              onClick={handleApplyAction}
              disabled={!selectedAction}
              iconName="Play"
            >
              Apply
            </Button>

            <Button
              variant="outline"
              size="sm"
              onClick={onClear}
              iconName="X"
            >
              Clear
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;